<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                  <sidebar></sidebar>
                </el-aside>
                <el-main>
                   <headSide></headSide> 
                   <div class="mt-30">
                      <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
                       <div class="mt-30 info_form">
                           <el-form ref="form" :rules="rules" :label-position="labelPosition" :model="form" label-width="100px">
                               <el-form-item label="文章标题 :" prop="title" style="width: 60%;">
                                    <el-input v-model="form.title"></el-input>
                                </el-form-item>
                                 <el-form-item label="文章类别 :" prop="category">
                                  <el-cascader
                                    :options="categoryList" 
                                    :props="optionProps"
                                    v-model="form.category"
                                    :show-all-levels="false" 
                                    style="width:53%;"
                                    @change="onChang()">
                                    </el-cascader>
                                </el-form-item>
                                <p class="file_text">图片信息，上传图片的格式为，279*145px，1M以内</p>
                                <el-form-item class="poster" prop="cover"   label="简介图片:" style="width: 60%;">
                                   <el-input v-model="form.cover" ></el-input>
                                    <el-upload
                                    class="upload-demo"
                                    :headers="{token:token}"
                                    action="/api/zwb/app/oss/public/upload"
                                    :on-success="onSuccess"
                                    :show-file-list="false"
                                    :before-upload="handlePictureCardPreview"
                                    list-type="picture">
                                    <button class="posterBtn" size="small" @click.prevent="">选择图片</button>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="发布时间 :" prop="createTime" style="width:100%;">
                                 <el-date-picker 
                                    type="date"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptionsStart"
                                    v-model="form.createTime"
                                    value-format='yyyy-MM-dd HH:mm:ss'
                                    @change="startTimeStatus"
                                style="width: 53%;"></el-date-picker>
                               </el-form-item>

                                <div class="tel">
                                    <p class="text_center">文章内容</p>
                                    <tinymceEditor class="mt-15" v-model="form.content" ref="editor"></tinymceEditor>
                                </div>
                                <div class="tel mt-30">
                                    <el-button type="success" @click="submitForm('form')">发布文章</el-button>
                                    <!-- <el-button type="warning" @click="resetForm('ruleForm')">预览资讯</el-button> -->
                                </div>
                           </el-form>
                       </div>
                   </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {release,releaseEdit} from "@/api/expert";
import {getTechnologyListById} from '@/api/information'
import {getDict} from "@/api/coment";
import {getToken} from '@/utils/auth'
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import tinymceEditor from '../../common/tinymceEditor.vue'
export default {
  components:{
      sidebar,headSide,commBanner,titleHead,contTitle,tinymceEditor
  }, 
  data(){
      return{
        headTitle:'专家视角',
        contTitle:'添加文章',
        obj:{
           title:'专家视角',   
           isShow:false,
            roleType:'',
            personalType:9,
        },
        companyObj:{
            imgUrl:require('@/assets/images/notmember.png')
        },
        paletteObj:{
            paletteTitle:'发布的文章',
            paletteName:'添加文章',
            paletteCount:3,
            paletteText:'删除文章',
            isShow:false,
            isDelete:true
        },
        form:{
            title:'',
            category:'',
            cover:'',//简介图片
            content:'',//文章内容
            createTime:''
        },
        rules:{
            title:[
              { required: true, message: '请输入资讯标题', trigger: 'blur' }
            ],
            category:[
                { required: true, message: '请选择资讯类别', trigger: 'change' }
            ],
            // cover:[  { required: true, message: '请上传资讯海报', trigger: 'change' }],
        },
        labelPosition:'left',
        industry_type:"",
        categoryList:[], //分类列表
        token:getToken(),
        optionProps:{
        value: 'id',
        label: 'name',
        children: 'children'
        },
		id:'',
        pickerOptionsStart:{
           disabledDate: time =>{
             if(this.form.createtime){
                 return time.getTime() <= Date.now();  
             }
           }
       },
      }
  },
  created(){
     this.getCailter();
     if(this.$store.state.user.userInfo.type ==2){
          this.obj.roleType = 2;
     }
	 if(this.$route.query.id){
		this.id = this.$route.query.id;
		this.getAngle(this.id); 
	 }
	 
  },
  methods:{
      submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {  
            if(this.id){
              this.getEdit();
            }else{
              this.getAdd();
            }
          }else{
			return false;
		  }
        });
      },
      //获取分类
       getCailter(){
       let params={
         code:this.industry_type
       };
       getDict(params).then(res=>{
         if(res.code ==0){
           this.categoryList = res.data[0].children;
         }
       }).catch(err=>{});
      },
       //文件上传前回调
     handlePictureCardPreview(file){
        const isLtM = file.size / 1024 / 1024 < 3;
        if(!isLtM){
          this.$message.error('上传文件大小不能超过 3MB!');
        }
        
          // }else{
      //     const isSize = new Promise((resolve, reject) => {
      //         const width = 279;
      //         const height = 145;
      //         const _URL = window.URL || window.webkitURL;
      //         const img = new Image();
      //         img.onload = () => {
      //             const valid = img.width >= width && img.height >= height && img.width === img.height;
      //             valid ? resolve() : reject();
      //         };
      //         img.src = _URL.createObjectURL(file);
      //     }).then(
      //         () => {
      //             return file;
      //         },
      //         () => {
      //             this.$message.error('图片尺寸限制最小为192 x 143，大小不可超过1MB');
      //             return Promise.reject();
      //         },
      //     );
      //     return isSize;
      // }
        return isLtM;
     },
     //文件上传成功
     onSuccess(res){
         if(res.code ==0){
            this.$message({
              message:'上传成功！',
              type: 'success',
            });
          this.form.cover = res.url;
         }
     },
	//选中类别
 	 onChang(){
	  this.form.category = this.form.category[this.form.category.length -1];
    },
	  startTimeStatus(value){
		 this.form.createtime = value;
	  },
	  //查询详情
	  getAngle(id){
		 let params = {id:id}
		 getTechnologyListById(params).then((res)=>{
			if(res.code == 0){
			  this.form = res.data;
			}
		 }).catch((err)=>{})
	  },
	  //添加
	  getAdd(){
		 release(this.form).then((res)=>{
			if(res.code ==0){
			this.$message({
			   message:'添加成功！',
			   type: 'success',
			   duration:1000,
			   onClose:()=>{
				  this.$router.push('/expert_angle')
			   }
			});
		   }
		 }).catch((err)=>{}) 
	  },
	  //编辑
	  getEdit(){
		releaseEdit(this.form).then((res)=>{
			if(res.code ==0){
			this.$message({
			   message:'编辑成功！',
			   type: 'success',
			   duration:1000,
			   onClose:()=>{
				  this.$router.push('/expert_angle')
			   }
			});
		  }
		}).catch((err)=>{})   
	  }
  },
}
</script>
<style scoped>
/* .el-aside{
    height: 900px;
} */
.el-form-item{
    text-align: left;
}
.tel{
    text-align: left;
}
.mt-15{
    margin-top: 15px;
}
.mt-30{
    margin-top: 30px;
}
.mt-20{
    margin-top: 20px;
}
.tips{
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #E28B8B; 
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}
.info_form>>>.el-input__inner{
    height: 50px;
}
.poster{
  position: relative;
}
 /deep/ .upload-demo{
     position: absolute;
     top: 0;
     right: 0;   
 }
.posterBtn{
     width: 125px;
     height: 50px;
     background: #E5E5E5;   
     font-size: 12px;
     font-family: Microsoft YaHei;
     font-weight: 400;
     color: #9A9A9A;
     border: none;
     line-height: 0;
 }
 /deep/.el-button--success{
     width: 114px;
     height: 40px;
     background: #3CBB36;
     border-radius: 3px;
     border: none;
     line-height: 0;
 }
  /deep/.el-button--warning{
    width: 114px;
    height: 40px;
    background: #FF7302;
    border-radius: 3px;
    border: none;
    line-height: 0;
 }
 .text_center{	
	font-size: 14px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #333333;
}

.file_text{
  font-size: 14px;
  color: #999999;
  margin: 15px 0px;
  text-align:left;
}
</style>


// WEBPACK FOOTER //
// src/view/expert/expert_angleAdd.vue